import "./sticky-sidebar.min.js";
(function ($) {
  // Sticky sidebar
  function initStickySidebar() {
    if ($('.inner-wrapper-sticky').length === 0) {
      $('.widget-area').stickySidebar({
        topSpacing: $('#wpadminbar').height() ? Math.round($('#wpadminbar').height() + 32) : 32,
        bottomSpacing: 32,
        containerSelector: '.has-sidebar',
        minWidth: 991,
      });
    }
  }

  const isReviewPage =
    $('.review-header .cta-card--review').length > 0
      && ('.widget-area .cta-card--review').length > 0
      ? true
      : false;

  if (!isReviewPage) {
    setTimeout(function () { initStickySidebar() }, 2000);
  }

  // Set scrollbar width
  function setScrollbarWidth() {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    $(':root').css('--scrollbar-width', `${scrollbarWidth}px`, '0px');
  }
  setScrollbarWidth();

  var isMobile = setIsMobile($(window).width());

  function setIsMobile(width) {
    return width < 768;
  }

  $(window).resize(function () {
    isMobile = setIsMobile($(window).width());
  });

  //Footer menu
  $('.footer-menu > li > a').on('click', function (event) {
    event.preventDefault();
    if (isMobile) {
      $(this).toggleClass('open');
      $(this).next('.sub-menu').slideToggle();
    }
  });

  //FAQ
  const faqItem = $('.schema-faq-section');
  faqItem.on('click', function (event) {
    event.preventDefault();

    const answer = $(this).children('.schema-faq-answer');
    answer.slideToggle();
    answer.toggleClass('show');
    answer.parent(faqItem).toggleClass('open');
  });

  //Guide post block
  const guidePost = $('.guide-post');
  const guidePostList = $('.guide-post .wrapper ol');
  let guidePostContent = null;

  if (guidePost.length > 0) {
    guidePostContent = $('.site-main article').first().find('h2').not('.h3');
  }

  if (guidePostContent !== null && guidePostContent.length > 0) {
    guidePostContent.each(function (index) {
      const navItem = $(this).text().replace(/(<([^>]+)>)/gi, "");
      if (navItem !== '') {
        $(this).prepend(`<span id="${index}" class="anchor"></span>`);
        if ($(this).parents('.has-decorated-heading').length === 0) {
          $(this).prepend(`<a href="#${index}">${index + 1}. </a>`);
        }
        guidePostList.append(`<li><a href="#${index}">${navItem}</a></li>`);
      }
    });
  } else {
    guidePost.css('display', 'none')
  }

  //CTA review header and sidebar
  const ctaReview = $('aside .cta-card--review');

  if (ctaReview.length > 0) {
    const offset = 100;
    const sideBar = $('.widget-area');
    const ctaReviewHeight = ctaReview.outerHeight();
    const ctaReviewWrapper = ctaReview.parent('.widget_block');
    ctaReviewWrapper.addClass('has-cta-review');

    const reviewHeader = $('.review-header');
    const reviewHeaderHeight = reviewHeader.outerHeight() - offset;
    let scrollOffset = $(window).scrollTop();

    $(':root').css('--review-header-height', `${reviewHeader.outerHeight()}px`, '0px');
    $(':root').css('--cta-review-height', `${ctaReviewHeight}px`, '0px');

    function checkscroll(scrollOffset) {
      if (scrollOffset >= reviewHeaderHeight) {
        sideBar.addClass('show-cta');
        reviewHeader.addClass('scrolable');
        ctaReviewWrapper.css('max-height', ctaReviewHeight + 32);
        setTimeout(function () { initStickySidebar() }, 500)
      } else {
        sideBar.removeClass('show-cta');
        reviewHeader.removeClass('scrolable');
        ctaReviewWrapper.css('max-height', '0px');
      }
    }

    checkscroll(scrollOffset);

    $(window).on('scroll', function () {
      scrollOffset = $(this).scrollTop();
      checkscroll(scrollOffset);
    });
  }
}(jQuery));